import {
  GET_PENDING_ORDER_AVAILABILTY_BY_SIZE_REQUEST,
  GET_PENDING_ORDER_AVAILABILTY_BY_SIZE_SUCCESS,
  GET_PENDING_ORDER_AVAILABILTY_BY_SIZE_ERROR
  } from "../actions/types";
  
  export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
      case GET_PENDING_ORDER_AVAILABILTY_BY_SIZE_REQUEST:
        return {
          loading: true,
        };
      case GET_PENDING_ORDER_AVAILABILTY_BY_SIZE_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_PENDING_ORDER_AVAILABILTY_BY_SIZE_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  